/* ONECART: カラーフィルタ(filter.v.option.顏色)の生値を15基本色＋其他に正規化して集約表示。
   - 生の色名(白色/象牙白/其他黑色2/BLU.CHECK/チーム名…)を classify() で基本色へ寄せる。
   - 生<li>は CSS で非表示、基本色ごとに件数合算したグループ行を描画。
   - グループクリック→該当基本色のメンバー生チェックボックスを一括 on/off→change発火で
     既存の適用機構(コレクション=Dawn facets.js / shop=独自AJAX)が絞り込む。
   - AJAX 再描画に MutationObserver で再グループ化(idempotent)。商品の元色名は不変。 */
(function () {
  if (window.__ocColorGroupInit) return;
  window.__ocColorGroupInit = true;

  // 表示する基本色の順序（其他は末尾）
  var ORDER = ['白色', '黑色', '紅色', '黃色', '橘色', '藍色', '綠色', '紫色', '粉色', '棕色', '灰色', '金色', '銀色', '膚色', '其他'];

  // 評価順＝最初にマッチした基本色（優先度を順序で表現）。キーワードは小文字。
  var RULES = [
    ['黑色', ['黑', '黒', 'black', 'blk', 'ブラック']],
    ['白色', ['象牙', '米白', '白', 'ivory', 'ivo', 'ecru', 'white', 'off white', 'offwhite']],
    ['銀色', ['銀', 'silver', 'slv']],
    ['金色', ['金', 'gold']],
    ['棕色', ['褐', '棕', '咖啡', 'coffee', 'chocolate', '巧克力', 'mocha', '摩卡', 'bronze', 'camel', '駝', '卡其', 'milk tea', 'milktea', '奶茶', '可可', 'tan', '焦糖', 'caramel']],
    ['黃色', ['黃', '黄', 'yellow', 'yel']],
    ['膚色', ['膚', '肤', 'skin', 'nude', 'beige', 'ベージュ', '米色', '米', '杏', 'apricot']],
    ['綠色', ['綠', '绿', 'green', 'khaki', 'mint', '薄荷', 'olive', '橄欖', 'ranger', 'pistachio', '松石', '抹茶', '草', 'lime', '石灰綠']],
    ['藍色', ['藍', '蓝', 'blue', 'blu', 'sax', 'navy', '紺', '薩克斯', '萨克斯', 'サックス', '海軍', '靛', 'denim', '丹寧']],
    ['紫色', ['紫', 'purple', 'violet', 'lavender', '薰衣草']],
    ['粉色', ['粉', 'pink', '玫瑰', 'rose', '裸粉', 'sakura', '櫻']],
    ['橘色', ['橙', '橘', 'orange', '珊瑚', 'coral']],
    ['紅色', ['紅', '红', 'red', 'cherry', '酒紅', 'wine', 'burgundy', '勃根', '酒红']],
    ['灰色', ['灰', 'gray', 'grey', 'charcoal', '炭']],
  ];

  function norm(s) {
    if (!s) return '';
    s = String(s).trim().toLowerCase();
    // 全角英数→半角
    s = s.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (c) {
      return String.fromCharCode(c.charCodeAt(0) - 0xFEE0);
    });
    return s;
  }

  var _ccache = {};
  function classify(label) {
    if (label in _ccache) return _ccache[label];
    var s = norm(label);
    var r = '其他';
    if (s) {
      for (var i = 0; i < RULES.length && r === '其他'; i++) {
        var kws = RULES[i][1];
        for (var j = 0; j < kws.length; j++) {
          if (s.indexOf(kws[j]) !== -1) { r = RULES[i][0]; break; }
        }
      }
    }
    _ccache[label] = r;
    return r;
  }

  var SWATCH = {
    '白色': '#f3f3f3', '黑色': '#1a1a1a', '紅色': '#d0021b', '黃色': '#f5c518', '橘色': '#f3811f',
    '藍色': '#2f6fdb', '綠色': '#3aa655', '紫色': '#8b5cf6', '粉色': '#f3a6c0', '棕色': '#8b5a2b',
    '灰色': '#9a9a9a', '金色': '#c9a227', '銀色': '#c4c4c4', '膚色': '#e7c4a0', '其他': 'conic-gradient(#d33,#fa0,#3a5,#39f,#a4f,#d33)'
  };

  function readLabel(li, input) {
    var t = li.querySelector('.facet-checkbox__text-label');
    if (t) return t.textContent.trim();
    return input ? input.value : '';
  }
  function readCount(li) {
    var t = li.querySelector('.facet-checkbox__text');
    if (t) { var m = t.textContent.match(/\((\d[\d,]*)\)/); if (m) return parseInt(m[1].replace(/,/g, ''), 10) || 0; }
    return 0;
  }

  function groupOne(details) {
    if (details.getAttribute('data-oc-color-grouped') === '1') return;
    // 値リスト＝checkbox を含む li がある ul（先頭 ul が別物/未描画の場合に対応）
    var rawUl = null;
    var uls = details.querySelectorAll('ul');
    for (var k = 0; k < uls.length; k++) {
      if (uls[k].querySelector('li input[type="checkbox"]')) { rawUl = uls[k]; break; }
    }
    if (!rawUl) return; // まだ描画されてない＝flag を立てずリトライさせる
    var lis = [];
    var kids = rawUl.children;
    for (var m = 0; m < kids.length; m++) {
      if (kids[m].tagName === 'LI') lis.push(kids[m]);
    }
    if (!lis.length) return;
    details.setAttribute('data-oc-color-grouped', '1'); // 成功確定後にマーク（再入防止）

    var buckets = {};
    lis.forEach(function (li) {
      var input = li.querySelector('input[type="checkbox"]');
      if (!input) return;
      var bc = classify(readLabel(li, input));
      if (!buckets[bc]) buckets[bc] = { count: 0, active: false, n: 0 };
      buckets[bc].count += readCount(li);
      buckets[bc].n += 1;
      if (input.checked) buckets[bc].active = true;
    });

    rawUl.classList.add('oc-color-raw-list'); // CSS で非表示

    var grouped = document.createElement('ul');
    grouped.className = 'oc-color-grouped list-unstyled';
    grouped.setAttribute('role', 'list');
    ORDER.forEach(function (bc) {
      var b = buckets[bc];
      if (!b) return;
      var li = document.createElement('li');
      li.className = 'oc-color-group-item';
      var sw = SWATCH[bc] || '#ccc';
      var swStyle = sw.indexOf('gradient') > -1 ? ('background:' + sw) : ('background-color:' + sw);
      li.innerHTML =
        '<button type="button" class="oc-color-group' + (b.active ? ' is-active' : '') + '" data-oc-color-group="' + bc + '" aria-pressed="' + (b.active ? 'true' : 'false') + '">' +
        '<span class="oc-color-swatch" style="' + swStyle + '"></span>' +
        '<span class="oc-color-label">' + bc + '</span>' +
        '<span class="oc-color-count">' + b.count + '</span>' +
        '</button>';
      grouped.appendChild(li);
    });
    rawUl.parentNode.insertBefore(grouped, rawUl.nextSibling);
    // 基本色は全表示＝省略していないので「顯示更多內容」は不要。グループ化できた時だけ隠す。
    var sm = details.querySelector('show-more-button');
    if (sm) sm.style.display = 'none';
  }

  function groupAll() {
    // Dawn は AJAX 再描画時 details の innerHTML を差し替える＝flag は残るが .oc-color-grouped は消える。
    // flag があっても集約UIが無ければ stale とみなし再構築（さもないと適用後に生色が復活）。
    document.querySelectorAll('details[id*="option.顏色"]').forEach(function (d) {
      if (d.getAttribute('data-oc-color-grouped') === '1' && d.querySelector('.oc-color-grouped')) return;
      d.removeAttribute('data-oc-color-grouped');
      groupOne(d);
    });
  }

  // ---- active facets(選択中チップ)も基本色1個に集約 ----
  var CLOSE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path></svg>';
  var colorMap = {}, colorKeys = {};
  function buildColorMap() {
    colorMap = {}; colorKeys = {};
    document.querySelectorAll('ul.oc-color-raw-list > li').forEach(function (li) {
      var input = li.querySelector('input[type="checkbox"]');
      if (!input) return;
      var lbl = readLabel(li, input);
      var key = norm(lbl);
      colorMap[key] = classify(lbl);
      colorKeys[key] = 1;
    });
  }
  function chipValueLabel(fr) {
    var inner = fr.querySelector('.active-facets__button-inner');
    if (!inner) return '';
    var t = '';
    inner.childNodes.forEach(function (n) { if (n.nodeType === 3) t += n.textContent; });
    t = t.replace(/\s+/g, ' ').trim();
    var idx = t.indexOf(':');
    return idx > -1 ? t.slice(idx + 1).trim() : t;
  }
  function consolidateChips() {
    document.querySelectorAll('.active-facets').forEach(function (af) {
      var items = [];
      af.querySelectorAll('facet-remove').forEach(function (fr) {
        if (fr.classList.contains('oc-color-chip')) return;
        var val = chipValueLabel(fr);
        var key = norm(val);
        if (!colorKeys[key]) return; // 色チップでない
        items.push({ fr: fr, basic: colorMap[key] || classify(val) });
      });
      var sig = items.map(function (x) { return x.basic; }).sort().join('|') + '#' + items.length;
      if (af.getAttribute('data-oc-color-sig') === sig) return; // 変化なし＝再構築しない(ループ防止)
      af.querySelectorAll('.oc-color-chip').forEach(function (n) { n.remove(); });
      items.forEach(function (x) { x.fr.style.display = 'none'; });
      ORDER.forEach(function (basic) {
        var grp = items.filter(function (x) { return x.basic === basic; });
        if (!grp.length) return;
        var con = document.createElement('span');
        con.className = 'oc-color-chip';
        con.innerHTML = '<button type="button" class="active-facets__button active-facets__button--light" data-oc-color-chip="' + basic + '">' +
          '<span class="active-facets__button-inner button button--tertiary">Color: ' + basic + ' <span class="svg-wrapper">' + CLOSE_SVG + '</span></span></button>';
        grp[0].fr.parentNode.insertBefore(con, grp[0].fr);
      });
      af.setAttribute('data-oc-color-sig', sig);
    });
  }
  // 基本色 basic のメンバー生checkboxを **全フォーム横断(PC/SP両方)** で willCheck に揃えて適用。
  // shop 独自AJAX は PC/SP 両フォームの checked を収集するため、片方だけ変えると解除が効かない→全同期。
  function setColorGroup(basic, willCheck, fireDetails) {
    document.querySelectorAll('ul.oc-color-raw-list > li').forEach(function (li) {
      var input = li.querySelector('input[type="checkbox"]');
      if (!input) return;
      if (classify(readLabel(li, input)) === basic && input.checked !== willCheck) input.checked = willCheck;
    });
    // 適用イベントはクリック元 details 内の input から(無ければ任意)。1回だけ発火＝二重適用防止。
    var fire = null;
    if (fireDetails) fire = fireDetails.querySelector('ul.oc-color-raw-list input[type="checkbox"]');
    if (!fire) fire = document.querySelector('ul.oc-color-raw-list input[type="checkbox"]');
    if (fire) {
      fire.dispatchEvent(new Event('input', { bubbles: true }));
      fire.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function removeColorGroup(basic) { setColorGroup(basic, false, null); }

  function run() { groupAll(); buildColorMap(); consolidateChips(); }

  // クリック→その基本色のメンバーを全フォーム同期で on/off→適用
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.oc-color-group') : null;
    if (!btn) return;
    e.preventDefault();
    var bc = btn.getAttribute('data-oc-color-group');
    var details = btn.closest('details');
    var willCheck = !btn.classList.contains('is-active');
    btn.classList.toggle('is-active', willCheck);
    btn.setAttribute('aria-pressed', willCheck ? 'true' : 'false');
    setColorGroup(bc, willCheck, details);
  });

  // 集約チップの × → その基本色のメンバーを全解除して適用
  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('[data-oc-color-chip]') : null;
    if (!chip) return;
    e.preventDefault();
    e.stopPropagation();
    removeColorGroup(chip.getAttribute('data-oc-color-chip'));
  });

  // AJAX 再描画に追従（idempotent。grouped/sig ガードで自分の変更による再発火は無害）
  function observe() {
    var target = document.getElementById('main-collection-filters') || document.body;
    if (!target || target.__ocColorObs) return;
    var timer = null;
    var obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(run, 25);
    });
    obs.observe(target, { childList: true, subtree: true });
    target.__ocColorObs = obs;
  }

  function init() { run(); observe(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () { run(); observe(); }, 0);
  });
  // shop ページはフィルタ注入が遅れるので軽くポーリング。色フィルタが出現＆集約できたら停止。
  var tries = 0;
  var poll = setInterval(function () {
    run();
    if (document.querySelector('details[id*="option.顏色"][data-oc-color-grouped]') || ++tries > 15) {
      clearInterval(poll);
    }
  }, 500);
})();
